import React from 'react';
import ProjectCard from '../ProjectCard/ProjectCard';
import './Projects.css';
import projectsData from '../../portfolioData/projectsData.json'

const Projects = () => {

    return (
        <div className='mb-5 mt-5'>
            <h4 className='text-center' id='work'>MY WORKS</h4>
            <h2 className='text-center mb-5' id='project'>Projects that are Clients Love</h2>
            <div className="row d-flex justify-content-center">
                {
                    projectsData.map(project => <ProjectCard project={project} ></ProjectCard>)
                }

            </div>
        </div>
    );
};

export default Projects;